import { Component, OnInit, Output,Input, EventEmitter, ViewChild } from '@angular/core';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { PlatformApiService, ResultFilter, PlanSearchCriteria } from 'src/app/services/platform-api.service';
import { AssessmentService } from 'src/app/services/assessment.service';
import { SessionService } from 'src/app/services/session.service';
import { MatDialog } from '@angular/material/dialog';
import { Assessment } from 'src/app/models/AssessmentModel';
import { CertificationAssessmentTypeListComponent } from 'src/app/secured/assessment/certification-assessment-type-list.component';
import { Account, Plan } from 'src/app/models/AccountModel';
import { AccountAssessment } from 'src/app/models/AssessmentModel';

@Component({
  selector: 'app-certification-reviewer',
  templateUrl: './certification-list.component.html',
  styleUrls:  ['./certification-list.component.scss']
})
export class CertificationListComponent implements OnInit {

  @Input() parentAccount: Account;
  @Input() account: Account;
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) certReviwerDataTable: DataTableComponent;
  assessmentList: AccountAssessment[];
  availablePlans: Plan[];

  constructor(private _platformApi: PlatformApiService, public sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  isSelectable(assessment) {
    return true;
  }

  addAssessment(event?) {
    let dialogRef;
    dialogRef = this.dialog.open(CertificationAssessmentTypeListComponent, {
      panelClass: 'flush-dialog',
      disableClose: false,
      autoFocus: false,
      data: {
        assessmentList :this.assessmentList
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.refresh();
    });
  }

  refresh() {
    this.certReviwerDataTable.executeLoadItems();
  }

  loadAssessments(filter: ResultFilter) {
    let assessmentListObservable;
    filter.searchData.includedAssessmentTypes = ['CERTIFICATION'];
    assessmentListObservable = this._platformApi.getAllAccountAssessments(filter);

    assessmentListObservable.subscribe(results => {
      this.assessmentList = results;
      console.log(results);
    })

  }

  selectAssessment(selectedAssessment: AccountAssessment) {
    if (selectedAssessment.status == 'COMPLETED') {
      this.certReviwerDataTable.executeLoadItems();
    }
    this._platformApi.getAccount(selectedAssessment.accountId).subscribe(account => {
      this.account = account
      if (selectedAssessment.status == 'COMPLETED') {
        this.stateChange.emit({ state: 'ASSESSMENT_REPORT', accountAssessment: selectedAssessment, account: this.account });
      } else {
        this.stateChange.emit({state:'EDIT_ASSESSMENT', accountAssessment: selectedAssessment, account: this.account});
      }
    });

  }

  newAssessment(selectedAccount: AccountAssessment) {
    this._platformApi.getPlans(new PlanSearchCriteria(true, undefined, undefined, undefined, selectedAccount.accountId)).subscribe(plans => {
      this.availablePlans = plans.results;
      const planObj = this.availablePlans[0];
      if (planObj) {
        this.certReviwerDataTable.executeLoadItems();
        this._platformApi.getPaymentStatus(selectedAccount.accountId).subscribe(status => {
          const isTrialAccount = status.paymentStatus.toLowerCase() == 'trial'? true : false;
          this._platformApi.getAssessments(new ResultFilter(undefined, undefined, undefined,undefined, {planId: status.plan.id, isInTrial: isTrialAccount, includeTypeList: ['CERTIFICATION']}))
            .subscribe(assessmentTemplates => {
            if (assessmentTemplates.count > 0){
              const dialogRef = this.dialog.open(CertificationAssessmentTypeListComponent, {
                panelClass: 'flush-dialog',
                data: {
                  account : selectedAccount,
                  planId: status.plan.id,
                  isInTrial: isTrialAccount,
                  defaultValue : assessmentTemplates.count == 1 ? assessmentTemplates.results[0] : undefined
                },
                disableClose: false,
                autoFocus: false,
              });
              dialogRef.afterClosed().subscribe(() => {
                this.refresh();
              });
            }
          });
        });
      }
    });
  }

  getRiskColor(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskColor({score});
  }

  getRiskLabel(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskLabel({score});
  }
}
